var map = {
	"./en.js": [
		"./src/lang/en.js",
		9,
		"src_lang_en_js"
	],
	"./jp.js": [
		"./src/lang/jp.js",
		9,
		"src_lang_jp_js"
	],
	"./tc.js": [
		"./src/lang/tc.js",
		7,
		"src_lang_tc_js"
	],
	"./tc_註解.js": [
		"./src/lang/tc_註解.js",
		9,
		"src_lang_tc__js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/lang lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;